<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>The Story Devotional: Discover Your Role In God’s Story: 365 Devotions</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ser"><a id="page1"></a><a href="#/contents#fn_0" id="sn_0"><img alt="TESTAMENT" src="images/9780310341895_conten_0007_002.jpg"/></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter3.vue?4cbf2e6f